import { render, staticRenderFns } from "./validate-modal.vue?vue&type=template&id=8b45315e"
import script from "./validate-modal.vue?vue&type=script&lang=js"
export * from "./validate-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports